var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"popup-address-card"},[_c('v-card-text',{ref:"content",staticClass:"pa-0 fill-height",on:{"!click":function($event){return _vm.onContentClick.apply(null, arguments)}}},[_c('category-block',{attrs:{"target":_vm.category,"position":_vm.position,"container":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }